<script setup>
// Selo do estado do registro SIP (linha ou ramal), com o erro do PABX no tooltip.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  state: { type: String, default: '' },
  error: { type: String, default: '' },
});

const { t } = useI18n();

const COLORS = {
  registered: 'bg-n-teal-3 text-n-teal-11 dark:bg-n-teal-4',
  failed: 'bg-n-ruby-3 text-n-ruby-11 dark:bg-n-ruby-4',
  disabled: 'bg-n-alpha-2 text-n-slate-10',
};
const DEFAULT_COLOR = 'bg-n-amber-3 text-n-amber-11 dark:bg-n-amber-4';

const cor = computed(() => COLORS[props.state] || DEFAULT_COLOR);
const rotulo = computed(() =>
  props.state ? t(`INBOX_MGMT.SIP_PABX.STATUS.${props.state}`) : '—'
);
</script>

<template>
  <span
    v-tooltip="error || null"
    class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md"
    :class="cor"
  >
    {{ rotulo }}
  </span>
</template>
